export const githubMarketplace = 'https://github.com/marketplace/private-stackshare';
